module.exports = __webpack_public_path__ + "static/media/close-modal.742a8b03.wav";